import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import styled from "styled-components";

import { HorizontalDivider } from "../../../common/components/core";
import { ProjectStateWithTxn } from "../../../types/project";
import { AmountFormatter } from "../../../utils/amount";

type ProjectAccountDetailProps = {
    project: ProjectStateWithTxn;
};

const ProjectAccountDetail = ({
    project,
}: ProjectAccountDetailProps): JSX.Element => {
    return (
        <Card.Body className="p-0 mb-3 border-0">
            <dl>
                <div>
                    <dd className="mb-2">
                        <span className="h1">
                            {AmountFormatter.format(project.totalAmount)}
                        </span>
                        <span className="ms-2 fw-bold">SGD</span>
                    </dd>
                    <dt className="text-label-grey mb-3">Total Amount</dt>
                </div>
                <HorizontalDivider />
                <Row xs={3}>
                    <Col className="border-end border-humble-grey">
                        <dt className="mt-2 mb-2 text-label-grey">
                            Bank Account Number
                        </dt>
                        {project.state.bankAccountRefs.map((account) => (
                            <dd>
                                <StyledAccount key={account} className="fw-bold">
                                    {account}
                                </StyledAccount>
                            </dd>
                        ))}
                    </Col>
                    <Col className="px-4">
                        <dt className="mt-2 mb-2 text-label-grey">
                            Number of Payment Transactions
                        </dt>
                        <dd className="fw-bold">{project.trxnCount}</dd>
                    </Col>
                </Row>
                <HorizontalDivider className="mb-0" />
            </dl>
        </Card.Body>
    );
};

const StyledAccount = styled.p`
    &:not(:last-child) {
        margin-bottom: 0;
    }
`;

export default ProjectAccountDetail;
